export const buildMenuTree = (items = []) => {
  const source = Array.isArray(items) ? items : [];

  if (source.some((item) => Array.isArray(item.children))) {
    return source;
  }

  const itemMap = new Map(
    source.map((item) => [
      Number(item.id ?? item.Id),
      { ...item, children: [] },
    ]),
  );
  const roots = [];

  itemMap.forEach((item) => {
    const parent = itemMap.get(Number(item.parentId ?? item.ParentId));
    if (parent) parent.children.push(item);
    else roots.push(item);
  });

  return roots;
};

export const flattenMenuTree = (items = [], depth = 0) =>
  items.flatMap((item) => [
    { ...item, depth },
    ...flattenMenuTree(item.children || [], depth + 1),
  ]);

export const findMenuByKey = (items = [], keyName) => {
  for (const item of items) {
    if ((item.keyName ?? item.KeyName) === keyName) return item;
    const nested = findMenuByKey(item.children || [], keyName);
    if (nested) return nested;
  }
  return null;
};

